import { io, Socket } from 'socket.io-client';
import { PORTAL_COTACOES_HABILITADO } from './portalCotacoesApi';

/**
 * Conexão websocket do Portal de Cotações (ADR 0005 do módulo).
 *
 * ⚠️ **É um singleton de propósito.** O hook global (`usePortalCotacoesSocket`, montado no
 * `App.tsx`) abre a conexão, e o detalhe da cotação precisa da **mesma** conexão para
 * entrar na sala daquela cotação. Duas conexões dariam duas sessões no servidor, dobrariam
 * os eventos recebidos e fariam o `cotacao:entrar` acontecer num socket diferente do que
 * escuta os avisos.
 *
 * Ninguém deve chamar `io()` para o Portal fora deste arquivo.
 */
let socket: Socket | null = null;

export function conectarPortalSocket(token: string): Socket | null {
  if (!PORTAL_COTACOES_HABILITADO) return null;
  if (socket) return socket;

  socket = io(process.env.REACT_APP_PORTAL_COTACOES_URL ?? '', {
    reconnectionDelay: 2000,
    // O backend valida este JWT no handshake e deriva a sala do usuário do próprio token
    // — payload autodeclarado nunca dá acesso a sala (mesmo contrato do at-36 do SOAC).
    auth: { token },
  });

  return socket;
}

/** A conexão viva, para quem precisa entrar/sair de sala. `null` sem conexão. */
export function obterPortalSocket(): Socket | null {
  return socket;
}

export function desconectarPortalSocket() {
  socket?.disconnect();
  socket = null;
}
